module.exports = __webpack_public_path__ + "static/media/04.Freight.95c87206.svg";